import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { deleteGeofence } from '../../services/GeofencesService';
import { Geofence, DeleteGeofenceRequest } from '../../types/Geofences';

type Result = UseMutationResult<Geofence, Error, DeleteGeofenceRequest>;

function useDeleteGeofence(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(deleteGeofence, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['geofences'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useDeleteGeofence;
